import MuliBlack from '../fonts/muli/Muli-Black.ttf';
import MuliBlackItalic from '../fonts/muli/Muli-BlackItalic.ttf';
import MuliBold from '../fonts/muli/Muli-Bold.ttf';
import MuliBoldItalic from '../fonts/muli/Muli-BoldItalic.ttf';
import MuliExtraBold from '../fonts/muli/Muli-ExtraBold.ttf';
import MuliExtraBoldItalic from '../fonts/muli/Muli-ExtraBoldItalic.ttf';
import MuliExtraLight from '../fonts/muli/Muli-ExtraLight.ttf';
import MuliExtraLightItalic from '../fonts/muli/Muli-ExtraLightItalic.ttf';
import MuliItalic from '../fonts/muli/Muli-Italic.ttf';
import MuliLight from '../fonts/muli/Muli-Light.ttf';
import MuliLightItalic from '../fonts/muli/Muli-LightItalic.ttf';
import MuliRegular from '../fonts/muli/Muli-Regular.ttf';
import MuliSemiBold from '../fonts/muli/Muli-SemiBold.ttf';
import MuliSemiBoldItalic from '../fonts/muli/Muli-SemiBoldItalic.ttf';

export {
  MuliBlack,
  MuliBlackItalic,
  MuliBold,
  MuliBoldItalic,
  MuliExtraBold,
  MuliExtraBoldItalic,
  MuliExtraLight,
  MuliExtraLightItalic,
  MuliItalic,
  MuliLight,
  MuliLightItalic,
  MuliRegular,
  MuliSemiBold,
  MuliSemiBoldItalic,
};



// WEBPACK FOOTER //
// ./src/shared/fonts.js